/**
 * Vacancies API — list, get, create, update, delete, changeStatus, syncHH.
 */

import { apiFetch } from './core'

export const vacancies = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/vacancies/${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/vacancies/${id}`),
    // Счёт вакансий без отдела: только числа, без id и названий —
    // у такой строки нет владельца, а значит и тенанта.
    orphanSummary: () => apiFetch('/vacancies/orphan-summary'),
    // Строки без отдела: отдельный явный режим списка. В обычной выдаче их
    // нет и быть не должно — видимость строится по отделу, а его нет.
    listUnassigned: () => apiFetch('/vacancies/?unassigned=true'),
    create: (data) => apiFetch('/vacancies/', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    update: (id, data) => apiFetch(`/vacancies/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    hhBindingOptions: (id) => apiFetch(`/vacancies/${id}/hh-binding-options`),
    bindHH: (id, data) => apiFetch(`/vacancies/${id}/hh-bindings`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    delete: (id) => apiFetch(`/vacancies/${id}`, { method: 'DELETE' }),
    changeStatus: (id, status) => apiFetch(`/vacancies/${id}/status?status=${encodeURIComponent(status)}`, {
        method: 'PATCH',
    }),
    reopen: (id, payload = {}) => apiFetch(`/vacancies/${id}/reopen`, {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    syncHH: (vacanciesData) => apiFetch('/vacancies/sync-hh', {
        method: 'POST',
        body: JSON.stringify(vacanciesData),
    }),
    parseText: (text) => apiFetch('/vacancies/parse-text', {
        method: 'POST',
        body: JSON.stringify({ text }),
    }),
    // Проверка текста перед публикацией: находки с цитатой, причиной и заменой.
    checkText: (payload) => apiFetch('/vacancies/check-text', {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    // Кандидаты из своей базы, которых нет в воронке этой вакансии.
    rediscovery: (id) => apiFetch(`/vacancies/${id}/rediscovery`),

    // Recruiting budget ledger — Этап 2 of HR Dashboard
    listCosts: (vacancyId) => apiFetch(`/vacancies/${vacancyId}/costs`),
    createCost: (vacancyId, payload) => apiFetch(`/vacancies/${vacancyId}/costs`, {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    updateCost: (vacancyId, costId, payload) => apiFetch(`/vacancies/${vacancyId}/costs/${costId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    }),
    deleteCost: (vacancyId, costId) => apiFetch(`/vacancies/${vacancyId}/costs/${costId}`, {
        method: 'DELETE',
    }),
}
